import UnexpectedStockOutflow from '../../domain/UnexpectedStockOutflow'


  export async function createUnexpectedStockOutflow(repository, data) {
    validateRequiredFields(data)

    const outflow = new UnexpectedStockOutflow(
      {
        id: data.id,
        idProducto: data.idProducto,
        estatus: data.estatus,
        fecha: data.fecha,
        identificador: data.identificador,
        piezas: data.piezas,
        unitario: data.unitario,
        importe: data.importe || (data.piezas * data.unitario),
        motivoSalida: data.motivoSalida,
        detalleSalida: data.detalleSalida,
        pedimentoAduana: data.pedimentoAduana,
        adjuntos: data.adjuntos,
      }
    )

    return repository.create(outflow.toPrimitives())
  }

  function validateRequiredFields(data) {
    const requiredFields = [
      'idProducto',
      'estatus',
      'fecha',
      'identificador',
      'piezas',
      'unitario',
      'motivoSalida',
      'detalleSalida'
    ]

    for (const field of requiredFields) {
      if (!data[field]) {
        throw new Error(`El campo ${field} es requerido`)
      }
    }
  }

